import React from 'react';
import ClassAssembly  from 'views/ClassAssembly6E2023';

const ClassAssemblyPage = () => {
    return <ClassAssembly />;
  };
  
  export default ClassAssemblyPage;